module.exports = __webpack_public_path__ + "static/media/payment-card.349a9a39.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/payment-card.svg
// module id = 2896
// module chunks = 0